var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center py-3"},[_c('h2',[_vm._v("Potfolio")]),_vm._v(" "),_c('div',{staticClass:"row mt-3"},_vm._l((_vm.portfolio),function(x,idx){return _c('div',{key:idx,staticClass:"col-sm-3 p-2"},[_c('c-portfolio-card',{attrs:{"link":x.link,"domain":x.domain,"product":x.product,"shortdesc":x.shortdesc,"img":x.img}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5fa0bae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portfolio.vue
// module id = null
// module chunks = 